import { LocalDate } from '@js-joda/core';

import { Bean, FormContextValues, ValidationRules } from '@dreryk/react-common';
import { DatePicker, dayValidator, StyledMaxWidth } from '@dreryk/react-components';

import { patientMedicalInformationTranslationKeys } from '../../../../translations';

const t = patientMedicalInformationTranslationKeys.chronicDisease.form.create;

const DIAGNOSIS_CREATION_DATE_FIELD_NAME = 'diagnosisCreationDate';

type DiagnosisCreationDateType = LocalDate;
export type DiagnosisCreationDateFormBeanPart = { [DIAGNOSIS_CREATION_DATE_FIELD_NAME]: DiagnosisCreationDateType };

type CreationDatePickerProps = Pick<FormContextValues<DiagnosisCreationDateFormBeanPart>, 'register' | 'watch'>;

export const CreationDatePicker = (props: CreationDatePickerProps): JSX.Element => {
   const VALIDATION_RULES: ValidationRules<Bean> = {
      required: true,
   };
   const selectedRemovalDate = props.watch<'diagnosisRemovalDate', LocalDate | undefined>('diagnosisRemovalDate');

   return (
      <StyledMaxWidth maxWidth={172}>
         <DatePicker
            testId={DIAGNOSIS_CREATION_DATE_FIELD_NAME}
            controller={props.register(DIAGNOSIS_CREATION_DATE_FIELD_NAME, VALIDATION_RULES)}
            label={t.diagnosisCreationDate.label}
            dayValidators={[
               dayValidator.dayAfterToday(),
               dayValidator.dayAfterReferenceDay(
                  selectedRemovalDate,
                  t.diagnosisRemovalDate.validate.cannotBeAfterRemovalDate
               ),
            ]}
            withNavigationArrows
         />
      </StyledMaxWidth>
   );
};
